export enum FundingErrorCode {
    all_rules_failed_custom_control_query = 'all_rules_failed_custom_control_query',
    cannotDetermineProcedurePerformedActivity = 'cannotDetermineProcedurePerformedActivity',
    cannotDetermineReportPerformedActivity = 'cannotDetermineReportPerformedActivity',
    cannotDetermineRequestPerformedActivity = 'cannotDetermineRequestPerformedActivity',
    canNotGetDateFirstProvidingActivity = 'canNotGetDateFirstProvidingActivity',
    generalError = 'generalError',
    invalidAgb = 'invalidAgb',
    invalidInsurerSettings = 'invalidInsurerSettings',
    invalidInvoiceSettings = 'invalidInvoiceSettings',
    missingCompensationCharge = 'missingCompensationCharge',
    missingPerformerAgbCode = 'missingPerformerAgbCode',
    missingPerformerRelationNumber = 'missingPerformerRelationNumber',
    missingPoortfunctionaris = 'missingPoortfunctionaris',
    missingReferrerAgbCode = 'missingReferrerAgbCode',
    missingRequesterRelationNumber = 'missingRequesterRelationNumber',
    multipleDeclarationsSameCareProductType = 'multipleDeclarationsSameCareProductType',
    noDeclarationRules = 'noDeclarationRules',
    noFundingResult = 'noFundingResult',
    noInsuranceHistory = 'noInsuranceHistory',
    noInsurerServiceDeclarationActivities = 'noInsurerServiceDeclarationActivities',
    noInsurerSettings = 'noInsurerSettings',
    noPatientInvoiceSettings = 'noPatientInvoiceSettings',
    noRelationNumberAvailable = 'noRelationNumberAvailable',
    ozpDbcOverlapTooLarge = 'ozpDbcOverlapTooLarge',
    serviceTypeNotSupported = 'serviceTypeNotSupported',
    uzoviNotLinkedToInsurer = 'uzoviNotLinkedToInsurer',
    uzoviNotValid = 'uzoviNotValid',
    waitingForPreviousFundingRecord = 'waitingForPreviousFundingRecord',
    zeroOrNegativeInvoiceAmount = 'zeroOrNegativeInvoiceAmount',
}
